import { render, staticRenderFns } from "./allIssue.vue?vue&type=template&id=f5cb2140"
import script from "./allIssue.vue?vue&type=script&lang=js"
export * from "./allIssue.vue?vue&type=script&lang=js"
import style0 from "./allIssue.vue?vue&type=style&index=0&id=f5cb2140&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports